//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('./BaseMediator')
const ClassFunc = require('../util/ClassFunc')
const DSBridge = require('../../libs/ds-bridge')
const Utils = require('../../utils')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_StaffMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_StaffMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_StaffMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    handleCreationComplete: function() {
        if (this._bridge.isList()) {
            this.target().organizationId = this._bridge.getRouteQuery('organizationId')
        }
        this.creationComplete()
    },
    handleRouteBack: function() {
        if (this._bridge.getRouteName() == 'UserOrgListStaff') {
            this._bridge.goToScene('UserOrgManageOrganization', {id: this._bridge.getRouteQuery('organizationId')})
        }
        else {
            this._bridge.back()
        }
    },
    handleRemoveService: function() {
        this._bridge.goToScene('UserOrgListStaff', {}, {organizationId: this.target().staff.organizationId})
    },
    /**
     * @api
     * Handle the customized event condition triggered by 
     * the scene instance.
     * @event The event object contains 
     * {type:String, data:Object, target:VueComponent}
     */
    handleCustomizedEvent: function(event) {
        if (event.type == 'invite-staff') {
            this.sendStaffInvite(event.data, this.convertor())
        }
        else {
            return true
        }
    },
    sendStaffInvite: function(data, convertor) {
        console.log('sendStaffInvite', data, convertor)
        const self = this
        const parameters = {
            staffId: data.id,
            organizationId: data.organizationId
        }
        self.loadViewObjectData(convertor, parameters, function(viewData) {
            console.log('load staff data', viewData)
            const startIndex = location.href.indexOf('/user-org')
            const link = location.href.substr(0, startIndex) + '/user-org/staff/invite/?ticket=' + viewData.ticket
            const shareParam = {
                title: convertor.localeProp('member-invite-title', {name: data.name, role: data.roleLabel}),
                desc: viewData.organizationName,
                imgUrl: Utils.QNImageUtil.imageView(viewData.organizationLogoUrl, 360, 360),
                link: link
            }
            console.log('share link', shareParam)
            DSBridge.callShare(shareParam)
        }, 'send')
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_StaffMediator, BaseMediator);

module.exports = tbs_controller_StaffMediator